// src/context/unitPartition/provider.ts
import moment from "moment";
import { useReducer } from "react";
import UnitPartitionContext, { internalState } from "./context";
import reducer from "./reducer";
import { execute } from "../../utils/helpers/execute";
import EndPoints from "../../services/end-points";
import { ICreateUnitPartition, IUpdateUnitPartition } from "../../models/unit-partition/request";
import { IUnitPartition } from "../../models/unit-partition/response";
import { IUnitPartitionQuery } from "../../models/unit-partition/query";

export interface IProps {
  children: React.ReactNode;
}

const UnitPartitionContextProvider: React.FC<IProps> = (props) => {
  const [state, dispatch] = useReducer(reducer, internalState);

  const getData = async () => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
        const { data } = await EndPoints.unitPartition.getAllUnitPartitions(state.query);
        dispatch({ type: "SET_LIST", payload: { list: data } });
      },
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
      },
    });
  };

  const getDetails = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });
        const { data } = await EndPoints.unitPartition.getUnitPartition(id);
        dispatch({ type: "SET_DETAILS", payload: { details: data } });
      },
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });
      },
    });
  };

  const createUnitPartition = async (request: ICreateUnitPartition) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "create" } });
        await EndPoints.unitPartition.createUnitPartition(request);
        getData();
      },
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "create" } });
      },
    });
  };

  const updateUnitPartition = async (id: number, request: IUpdateUnitPartition) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "update" } });
        await EndPoints.unitPartition.updateUnitPartition(id, request);
        getData();
      },
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "update" } });
      },
    });
  };

  const deleteUnitPartition = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "delete" } });
        await EndPoints.unitPartition.deleteUnitPartition(id);
        getData();
      },
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "delete" } });
      },
    });
  };
  const setDetails = async (data?: IUnitPartition) => {
    // dispatch({ type: 'SET_DETAILSS', payload: { details: data } })
  };
  const exportExcel = async (request: any) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
        const data = await EndPoints.tag.exportExcel(request, state.query);
        const url = window.URL.createObjectURL(new Blob([data.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Tags-${moment().format("yyyy-MM-d")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };
  return (
    <UnitPartitionContext.Provider
      value={{
        ...state,
        actions: {
          getData,
          getDetails,
          setDetails,
          exportExcel,

          createUnitPartition,
          updateUnitPartition,
          deleteUnitPartition,
          setSearch: (search?: string) => dispatch({ type: "SET_SEARCH", payload: { search } }),
          setQuery: (query: IUnitPartitionQuery) => dispatch({ type: "SET_QUERY", payload: { query } }),
        },
      }}
    >
      {props.children}
    </UnitPartitionContext.Provider>
  );
};

export default UnitPartitionContextProvider;
